import { useEffect } from "react";

export function ExternalRedirect({ url }) {
  useEffect(() => {
    window.location.replace(url);
  }, [url]);

  return null;
}
